import React from 'react';
import { createEmptyLookAndFeelUnloggedFrame, } from './look-and-feel-unlogged.vm';
export const LookAndFeelUnloggedContext = React.createContext(Object.assign(Object.assign({}, createEmptyLookAndFeelUnloggedFrame()), { setCssText: () => { }, setCssFileStatus: () => { }, setLogoDataUrl: () => { }, setLogoFileStatus: () => { }, refresh: () => { } }));
export const useLookAndFeelUnloggedContext = () => React.useContext(LookAndFeelUnloggedContext);
